module.exports = __webpack_public_path__ + "media/images/icons/academic-development_02-876b17368f51a4edc3c27cf12f27e06e.svg";